import { render } from "./HeadBottom.vue?vue&type=template&id=2e803648&scoped=true"
import script from "./HeadBottom.vue?vue&type=script&lang=js"
export * from "./HeadBottom.vue?vue&type=script&lang=js"

import "./HeadBottom.vue?vue&type=style&index=0&id=2e803648&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e803648"]])

export default __exports__